<template>
  <div id="unity-container" class="unity-desktop">
    <div class="loader" v-if="loading < 100">
      <div class="loadingCount">{{ parseInt(loading) }}%</div>
      <div class="loadingio-spinner-rolling-20i2673fhl9">
        <div class="ldio-0nttyi2ot5a">
          <div></div>
        </div>
      </div>
    </div>
    <canvas id="unity-canvas" width="600" height="450"></canvas>
    <div id="unity-loading-bar">
      <div id="unity-logo"></div>
      <div id="unity-progress-bar-empty">
        <div id="unity-progress-bar-full"></div>
      </div>
    </div>
    <!-- <div id="unity-mobile-warning">
      WebGL builds are not supported on mobile devices.
    </div>-->
    <div id="unity-footer">
      <div id="unity-webgl-logo"></div>
      <div id="unity-fullscreen-button"></div>
      <div id="unity-build-title" @click="widthg()"></div>
    </div>
    <div id="preview-controls" class="preview-controls" v-if="!playing && ready">
      <div title="camera" class="btn">
        <i class="fa-solid fa-camera-rotate"></i>
      </div>
      <div title="position (w)" class="btn" @click="whereMode()">
        <Icon icon="position"/>
      </div>
      <div title="rotation (e)" class="btn" @click="eulerMode()">
        <Icon icon="rotation"/>
      </div>
      <div title="scale (r)" class="btn" @click="resizeMode()">
       <Icon icon="scale"/>
      </div>
      <div title="delete (d)" class="btn" @click="removeSelectedObject()">
        <i class="fa-solid fa-trash-can"></i>
      </div>
    </div>

    <div class="mobile-controls">
      <div class="btn">
        <i class="fas fa-backward fa-xl"></i>
      </div>
      <div class="btn">
        <i class="fas fa-step-backward fa-xl"></i>
      </div>
      <div @click="hidePlayAndPause" class="btn">
        <svg id="pause_SVG" width="15" height="21" viewBox="0 0 15 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.63068 20.0757C1.2967 20.0757 0.215942 18.9949 0.215942 17.661V2.56684C0.215942 1.23286 1.2967 0.1521 2.63068 0.1521C3.96465 0.1521 5.04541 1.23286 5.04541 2.56684V17.661C5.04661 18.9949 3.96465 20.0757 2.63068 20.0757Z" fill="white"/>
        <path d="M12.2908 20.0757C10.9569 20.0757 9.8761 18.9949 9.8761 17.661V2.56684C9.8761 1.23286 10.9569 0.1521 12.2908 0.1521C13.6248 0.1521 14.7057 1.23286 14.7057 2.56684V17.661C14.7057 18.9949 13.6248 20.0757 12.2908 20.0757Z" fill="white"/>
        </svg>
        <!--  -->
        <svg id="play_SVG" width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.30087 1.48069C0.292522 1.10347 0.689048 0.853279 1.02593 1.02321L23.8373 12.5298C24.1843 12.7048 24.2076 13.1916 23.8789 13.399L1.63277 27.4354C1.30402 27.6428 0.874685 27.4122 0.866086 27.0236L0.30087 1.48069Z" fill="white"/>
        </svg>
      </div>
      <div class="btn">
        <i class="fas fa-step-forward fa-xl"></i>
      </div>
      <div class="btn">
        <i class="fas fa-forward fa-xl"></i>
      </div>
    </div>
  </div>
</template>

<script>
// import {createUnityInstance} from './previewAssets/3.loader.js'
// import unityweb from './previewAssets/3.data.unityweb'
// import unityFramework from './previewAssets/3.framework.js.unityweb'
// import wasunity from './previewAssets/3.wasm.unityweb'

import {
  db,
  jsonFileStorageRef,
  storiesRef,
  webglStorageRef
} from '../../../firebaseDB'
import { mapGetters, mapState } from 'vuex'
import Icon from '../../global/Icon.vue'
import _ from 'lodash'
import { Point } from 'gojs'
export default {
  data () {
    return {
      story_id:'',
      story_link:'',
      playing: false,
      objectId: null,
      loading: 0,
      spawned: [],
      ready: false,
      addedElements: [],
      activeCharacter: {},
    }
  },
  components: {
    Icon
  },
  props: ['width', 'height'],
  beforeDestroy () {
    this.$root.$off('removeFromPreview')
    this.$root.$off('sendJson')
    this.$root.$off('controlPreview')
  },
  mounted () {
    window.RetrieveCurrentTimelineTime = this.RetrieveCurrentTimelineTime
    window.GetPreviewAssetPositionWithParameters = this.GetPreviewAssetPositionWithParameters
    window.GetPreviewAssetRotationWithParameters = this.GetPreviewAssetRotationWithParameters
    window.GetPreviewAssetScaleWithParameters = this.GetPreviewAssetScaleWithParameters
    window.GetPreviewAssetSelectedId = this.GetPreviewAssetSelectedId
    window.GetPreviewAssetPositionWithJson = this.GetPreviewAssetPositionWithJson
    window.GetPreviewAssetRotationWithJson = this.GetPreviewAssetRotationWithJson
    window.GetPreviewAssetScaleWithJson = this.GetPreviewAssetScaleWithJson
    setTimeout(() => {
      const storyId = localStorage.getItem('storyId')
      db.ref('stories/' + storyId).on(
        'value',
        snapshot => {
          snapshot.forEach(child => {
            if (child.key == 'latest_export') {
              this.story_id = child.val();
              console.log(this.story_id)
              jsonFileStorageRef
                .child(storyId + '/' + child.val())
                .getDownloadURL()
                .then(url => {
                  this.story_link = url;
                  console.log(this.story_link);
                })
            }
          })
        },
        errorObject => {
          console.log('The read failed: ' + errorObject.name)
        }
      )
      this.initializePreview()
    }, 3000)
  },
  methods: {
    initializePreview() {
      var config = {
        dataUrl: 'https://sinhvho.com/ibegoo-preview/nightly/Build/3.data.unityweb',
        frameworkUrl:
          'https://sinhvho.com/ibegoo-preview/nightly/Build/3.framework.js.unityweb',
        codeUrl: 'https://sinhvho.com/ibegoo-preview/nightly/Build/3.wasm.unityweb',
        streamingAssetsUrl: 'StreamingAssets',
        companyName: 'iBEGOO',
        productName: 'ibegoo-webgl-preview',
        productVersion: '0.1'
      }
      // var unityInstance;
      var container = document.getElementById('unity-container')
      var canvas = document.getElementById('unity-canvas')
      var loadingBar = document.getElementById('unity-loading-bar')
      var progressBarFull = document.getElementById('unity-progress-bar-full')
      var fullscreenButton = document.getElementById('unity-fullscreen-button')
      var mobileWarning = document.getElementById('unity-mobile-warning')
      if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
        container.className = 'unity-mobile'
        config.devicePixelRatio = 1
        mobileWarning.style.display = 'block'
        setTimeout(() => {
          mobileWarning.style.display = 'none'
        }, 5000)
      } else {
        canvas.style.width = this.width
        canvas.style.height = this.height
      }
      loadingBar.style.display = 'block'
      // var script = document.createElement("script");
      // script.src = loaderUrl;
      createUnityInstance(canvas, config, progress => {
        progressBarFull.style.width = 100 * progress + '%'
        this.loading = 100 * progress
      })
        .then(unityInstance => {
          loadingBar.style.display = 'none'
          window.unityInstance = unityInstance
          this.ready = true
          this.$set(this.$store.state,"unityInstanceReady",true)
          setTimeout(() => {
            this.characters.map(char => this.spawn(char))
            // this.characters.map(char => console.log(char))
          }, 5000)
          this.$root.$on('removeFromPreview', id => {
            if (id) {
              window.unityInstance.SendMessage(
                'AssetHandler',
                'RemoveAssetWithId',
                id.toString()
              )
            }
          })
          this.$root.$on('changeObjectId', id => {
            if (id) {
             this.objectId = id
            }
          })
          this.$root.$on('sendJson', () => {
            this.SendStoryJsonToUnity(this.story_link)
          })
          this.$root.$on('removeWaypoint', (mv_id, id, parentId) => { 
           
            var point = {
              id: id.toString(),
              movementId: mv_id
            }
             console.log(point)
            unityInstance.SendMessage(parentId.toString(),"RemoveWaypointWithJson",JSON.stringify(point)); 
          })
          this.$root.$on('removeSubnode', (id, type, parentId) => {
            switch (type) {
              case 'Animation':
                unityInstance.SendMessage(parentId.toString(),"RemoveAnimationWithId", id.toString()); 
                break;
              case 'TextToSpeech':
                unityInstance.SendMessage(parentId.toString(),"RemoveVoiceWithId", id.toString()); 
                break;
              case 'Light':
                unityInstance.SendMessage(parentId.toString(),"RemoveLightWithId", id.toString()); 
                break;
              case 'Effect':
                unityInstance.SendMessage(parentId.toString(),"RemoveEffectWithId", id.toString()); 
                break;
              case 'Sound':
                unityInstance.SendMessage(parentId.toString(),"RemoveSoundWithId", id.toString()); 
                break;
              case 'Movement':
                window.unityInstance.SendMessage(parentId.toString(),"RemoveMovementWithId", id.toString());
                break
              default:
                break;
            }
          })

          this.$root.$on('playScene', () => {
            // console.log(this.story_link)
            this.SendStoryJsonToUnity(this.story_link)
            setTimeout(()=>{
              window.unityInstance.SendMessage("PreviewManager","PlayScene", "");
            },2500)
            this.playing = true;
          })
          this.$root.$on('editScene', () => {
            this.reloadPreview()
            this.playing =  false;
          })
          this.$root.$on('controlPreview', ({ state, param }) => {
            // console.log('this')
            let listOfCommands = [
              'Pause',
              'Play',
              'Rewind',
              'ReSet',
              'SetPlaybackSpeed',
              'SetTime'
            ]
            let alt = param || ''
            listOfCommands.indexOf(state) != -1
              ? window.unityInstance.SendMessage('TimelineHandler', state, parseFloat(alt.toString()))
              : console.error('Command not found !')
          })
          fullscreenButton.onclick = () => {
            unityInstance.SetFullscreen(1)
          }
        })
        .catch(message => {
          alert(message)
        })
      document.addEventListener('click', function (e) {
        if (window.unityInstance) {
          if (e.target.id == 'unity-canvas') {
            // Clicked on canvas
            window.unityInstance.SendMessage(
              'PreviewManager',
              'FocusCanvas',
              '1'
            )
          } else {
            // Clicked outside of canvas
            window.unityInstance.SendMessage(
              'PreviewManager',
              'FocusCanvas',
              '0'
            )
          }
        }
      })
    },
    reloadPreview() {
      var config = {
        dataUrl: 'https://sinhvho.com/ibegoo-preview/nightly/Build/3.data.unityweb',
        frameworkUrl:
          'https://sinhvho.com/ibegoo-preview/nightly/Build/3.framework.js.unityweb',
        codeUrl: 'https://sinhvho.com/ibegoo-preview/nightly/Build/3.wasm.unityweb',
        streamingAssetsUrl: 'StreamingAssets',
        companyName: 'iBEGOO',
        productName: 'ibegoo-webgl-preview',
        productVersion: '0.1'
      }
      var canvas = document.getElementById('unity-canvas')
      var loadingBar = document.getElementById('unity-loading-bar')
      var progressBarFull = document.getElementById('unity-progress-bar-full')
      loadingBar.style.display = 'block'
      this.ready = false
      createUnityInstance(canvas, config, progress => {
        progressBarFull.style.width = 100 * progress + '%'
        // this.loading = 100 * progress
      })
        .then(unityInstance => {
          loadingBar.style.display = 'none'
          window.unityInstance = unityInstance
          this.ready = true
          this.$set(this.$store.state,"unityInstanceReady",true)
          this.addedElements = []
          setTimeout(() => {
            this.characters.map(char => this.spawn(char))
          }, 5000)
        })
    },
    removeSelectedObject() {
      if (this.objectId) {
        window.unityInstance.SendMessage(
          'AssetHandler',
          'RemoveAssetWithId',
          this.objectId.toString()
        )
        this.$store.dispatch(
          'updateCharacters',
          this.characters.filter(char => {
            return char.objectId != this.objectId
          })
        )
      this.objectId = null
      }
    },
    hidePlayAndPause() {
      const playSVG = document.getElementById("play_SVG");
      const pauseSVG = document.getElementById("pause_SVG");

      if (playSVG.style.display == 'none') {
        pauseSVG.style.display = 'none'
        playSVG.style.display = 'block'
      } else {
        playSVG.style.display = 'none'
        pauseSVG.style.display = 'block'
      }
    },
    RetrieveCurrentTimelineTime (x) {
      // console.log(x)
    },
    
    GetPreviewAssetPositionWithParameters (id, x, y, z) {
      this.$store.dispatch(
        'updateCharacters',
        this.characters.map(char =>
          char.objectId == id
            ? { ...char, origin: { ...char.origin, position: [x, y, z] } }
            : char
        )
      )
    },
    GetPreviewAssetRotationWithParameters (id, x, y, z) {
      this.$store.dispatch(
        'updateCharacters',
        this.characters.map(char =>
          char.objectId == id
            ? { ...char, origin: { ...char.origin, rotation: [x, y, z] } }
            : char
        )
      )
    },
    GetPreviewAssetScaleWithParameters (id, scale) {
      this.$store.dispatch(
        'updateCharacters',
        this.characters.map(char =>
          char.objectId == id ? { ...char, scale } : char
        )
      )
    },
    GetPreviewAssetSelectedId (id) {
      this.$store.dispatch(
        'updateCharacters',
        this.characters.map(char =>
          char.objectId == id
            ? { ...char, active: true }
            : { ...char, active: false }
        )
      )
    },
    GetPreviewAssetPositionWithJson (json) {
      const { id, x, y, z } = JSON.parse(json)
      this.$store.dispatch(
        'updateCharacters',
        this.characters.map(char =>
          char.objectId == id
            ? { ...char, origin: { ...char.origin, position: [x, y, z] } }
            : char
        )
      )
    },
    GetPreviewAssetRotationWithJson (json) {
      const { id, x, y, z } = JSON.parse(json)
      this.$store.dispatch(
        'updateCharacters',
        this.characters.map(char =>
          char.objectId == id
            ? { ...char, origin: { ...char.origin, rotation: [x, y, z] } }
            : char
        )
      )
    },
    GetPreviewAssetScaleWithJson (json) {
      const { id, scale } = JSON.parse(json)
      this.$store.dispatch(
        'updateCharacters',
        this.characters.map(char =>
          char.objectId == id ? { ...char, scale } : char
        )
      )
    },
    widthg () {
      // console.log(this.width)
    },
    spawn (char) {
      if (this.ready) {
        let charJson = {
          id: char.objectId.toString(),
          name: char.name,
          webglAssetBundle: char.AndroidAssetBundle,
          startTime: parseFloat(char.startTime).toString(),
          endTime: char.endTime.toString()
        }
        window.unityInstance.SendMessage(
          'AssetHandler',
          'SpawnWithJson',
          JSON.stringify(charJson)
        )
        setTimeout(() => {
          this.updateCharacter(char)
          window.unityInstance.SendMessage('PreviewManager', 'FocusCanvas', '0')
        }, 3000)
      }
    },
    updateCharacter (char) {
      if (this.ready) {
        let rotationJson = {
          x: char.origin.rotation[0],
          y: char.origin.rotation[1],
          z: char.origin.rotation[2]
        }
        let positionJson = {
          x: char.origin.position[0],
          y: char.origin.position[1],
          z: char.origin.position[2]
        }

        let newChar = this.spawned.filter(el => el.id == char.objectId)
        if(newChar[0].char.name != char.name) {

          window.unityInstance.SendMessage(
            char.objectId.toString(),
            'SwapAssetModel',
            `{"name":"${char.name}","webglAssetBundle":"${char.AndroidAssetBundle}"}`
          )
          this.spawned = this.spawned.map(el => {
            if (el.id === char.objectId) {
              return {
                  ...el,
                char: char
              }
            }
            return el
          }
          )
          // setTimeout(() => {
          //   this.updateCharacter(char)
          //   window.unityInstance.SendMessage('PreviewManager', 'FocusCanvas', '0')
          // }, 3000)
          // return;
        }
        let type = char.type.charAt(0).toLowerCase() + char.type.slice(1) + 'Elements'
        if(char.hasOwnProperty(type) || char.hasOwnProperty(`${char.type}Elements`)){
          let naming = ( char.hasOwnProperty(`${char.type}Elements`) ? `${char.type}Elements`: type )
          let element = char[naming]
          let elem
          for (var i = element.length - 1; i >= 0; i--) {
            const el = element[i]
            switch (el.elementType){
              case 'TextToSpeech':
              let lastIndex =
                el.textToSpeech.languageCode.country.indexOf(' (') + 1
              let language = el.textToSpeech.languageCode.country.substr(
                0,
                lastIndex
              )
              lastIndex = el.textToSpeech.languageCode.name.indexOf('-')
              let firstLanguage = el.textToSpeech.languageCode.name.substr(
                0,
                2
              )
              let endLanguage = el.textToSpeech.languageCode.name.substr(
                lastIndex,
                3
              )
              let voiceLanguage = firstLanguage + endLanguage
                var jsonInfo = 
                  JSON.stringify({
                    id: el.id,
                    text: el.textToSpeech.text,
                    startTime: parseFloat(el.textToSpeech.startTime),
                    endTime: parseFloat(el.textToSpeech.endTime),
                    voiceGender: el.textToSpeech.gender,
                    voiceEffect: el.textToSpeech.voiceEffect,
                    voiceLanguage
                  });
                elem = this.addedElements.filter(item => item.id == el.id)
                elem = elem.length ? elem[0] : null
                if (!elem) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddVoiceWithJson", jsonInfo);
                  this.addedElements.push({
                    id: el.id,
                    textToSpeech: {...el.textToSpeech}
                  })
                } else if (!_.isEqual(elem.textToSpeech, el.textToSpeech)) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"RemoveVoiceWithId", el.id.toString());
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddVoiceWithJson", jsonInfo);
                  this.addedElements = this.addedElements.filter(item => item.id != el.id)
                  this.addedElements.push({
                    id: el.id,
                    textToSpeech: {...el.textToSpeech}
                  })
                }
                break;
              case 'Animation':
                var jsonInfo = 
                  JSON.stringify({
                    id: el.id,
                    name: el.animation.name,
                    startTime: parseFloat(el.animation.startTime),
                    endTime: parseFloat(el.animation.endTime),
                  });
                elem = this.addedElements.filter(item => item.id == el.id)
                elem = elem.length ? elem[0] : null
                if (!elem) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddAnimationWithJson", jsonInfo);
                  this.addedElements.push({
                    id: el.id,
                    animation: {...el.animation}
                  })
                } else if (!_.isEqual(elem.animation, el.animation)) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"RemoveAnimationWithId", el.id.toString());
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddAnimationWithJson", jsonInfo);
                  this.addedElements = this.addedElements.filter(item => item.id != el.id)
                  this.addedElements.push({
                    id: el.id,
                    animation: {...el.animation}
                  })
                }
                break;
              case 'Movement':
                var jsonInfo = 
                  JSON.stringify({
                    id: el.movement.id,
                    duration: el.movement.duration,
                    pathType: el.movement.pathType,
                    lookAtValue: parseFloat(el.movement.lookAtValue),
                    loop: el.movement.loop,
                    isSpeedBased: el.movement.isSpeedBased,
                    startTime: parseFloat(el.movement.waypoints[0].startTime),
                    endTime: parseFloat(el.movement.waypoints[el.movement.waypoints.length - 1].endTime),
                  });
                elem = this.addedElements.filter(item => item.id == el.id)
                elem = elem.length ? elem[0] : null
                if (!elem) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddMovementWithJson", jsonInfo);
                  el.movement.waypoints.forEach(point => {
                    var waypoint = 
                      JSON.stringify({
                        id: point.id.toString(),
                        movementId: el.movement.id,
                        startTime: parseFloat(point.startTime),
                        endTime: parseFloat(point.endTime),
                        point: [
                          parseFloat(point.point[0]),
                          parseFloat(point.point[1]),
                          parseFloat(point.point[2])
                        ]
                      });
                    window.unityInstance.SendMessage(char.objectId.toString(),"AddWaypointToMovementWithJson", waypoint);
                  });
                  this.addedElements.push({
                    id: el.movement.id,
                    movement: {...el.movement}
                  })
                } else if (!_.isEqual(elem.movement, el.movement)) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"RemoveMovementWithId", el.movement.id.toString());
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddMovementWithJson", jsonInfo);
                  this.addedElements = this.addedElements.filter(item => item.id != el.movement.id)
                  el.movement.waypoints.forEach(point => {
                    var waypoint = 
                      JSON.stringify({
                        id: point.id.toString(),
                        movementId: el.movement.id,
                        startTime: parseFloat(point.startTime),
                        endTime: parseFloat(point.endtime),
                        point: point.point
                      });
                    window.unityInstance.SendMessage(char.objectId.toString(),"AddWaypointToMovementWithJson", waypoint);
                  });
                  this.addedElements.push({
                    id: el.id,
                    movement: {...el.movement}
                  })
                }
                break;
              case 'Sound':
                var jsonInfo = 
                  JSON.stringify({
                    id: el.id,
                    name: el.sound.name,
                    audioUrl :el.sound.audioUrl,
                    audioType: el.sound.audioType,
                    startTime: parseFloat(el.sound.startTime),
                    endTime: parseFloat(el.sound.endTime),
                    loop: false,
                    volume: parseFloat(1),
                    pitch: parseFloat(1),
                    parentObjectId: char.objectId.toString()
                  });
                elem = this.addedElements.filter(item => item.id == el.id)
                elem = elem.length ? elem[0] : null
                if (!elem) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddSoundWithJson", jsonInfo);
                  this.addedElements.push({
                    id: el.id,
                    sound: {...el.sound}
                  })
                } else if (!_.isEqual(elem.sound, el.sound)) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"RemoveSoundWithId", el.id.toString());
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddSoundWithJson", jsonInfo);
                  this.addedElements = this.addedElements.filter(item => item.id != el.id)
                  this.addedElements.push({
                    id: el.id,
                    sound: {...el.sound}
                  })
                }
                break;
              case 'Effect':
                var jsonInfo = 
                  JSON.stringify({
                    id: el.id,
                    name: el.effect.name,
                    startTime: parseFloat(el.effect.startTime),
                    endTime: parseFloat(el.effect.endTime),
                    prefabName: el.effect.prefabName,
                    effectType: el.effect.effectType,
                    loop: el.effect.loop,
                    parentObjectId: char.objectId.toString()
                  });
                elem = this.addedElements.filter(item => item.id == el.id)
                elem = elem.length ? elem[0] : null
                if (!elem) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddEffectWithJson", jsonInfo);
                  this.addedElements.push({
                    id: el.id,
                    effect: {...el.effect}
                  })
                } else if (!_.isEqual(elem.effect, el.effect)) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"RemoveEffectWithId", el.id.toString());
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddEffectWithJson", jsonInfo);
                  this.addedElements = this.addedElements.filter(item => item.id != el.id)
                  this.addedElements.push({
                    id: el.id,
                    effect: {...el.effect}
                  })
                }
                break;
              case 'Light':
                let lightFields = {
                  id: el.id,
                  name: el.light.name,
                  type: el.light.lightType,
                  color: el.light.color,
                  startTime: parseFloat(el.light.startTime),
                  endTime: parseFloat(el.light.endTime),
                  range: parseFloat(el.light.range),
                  exposure: parseFloat(el.light.exposure),
                  indirectMultiplier: parseFloat(el.light.indirectMultiplier),
                  shadowType: el.light.shadowType,
                  shadowStrength: parseFloat(el.light.shadowStrength),
                  parentObjectId: char.objectId.toString()
                }
                if (el.light.type === 'spot') {
                  lightFields.innerSpotAngle = parseFloat(el.light.innerSpotAngle)
                  lightFields.outerSpotAngle = parseFloat(el.light.outerSpotAngle)
                }
                var jsonInfo = JSON.stringify(lightFields);
                elem = this.addedElements.filter(item => item.id == el.id)
                elem = elem.length ? elem[0] : null
                if (!elem) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddLightWithJson", jsonInfo);
                  this.addedElements.push({
                    id: el.id,
                    light: {...el.light}
                  })
                } else if (!_.isEqual(elem.light, el.light)) {
                  window.unityInstance.SendMessage(char.objectId.toString(),"RemoveLightWithId", el.id.toString());
                  window.unityInstance.SendMessage(char.objectId.toString(),"AddLightWithJson", jsonInfo);
                  this.addedElements = this.addedElements.filter(item => item.id != el.id)
                  this.addedElements.push({
                    id: el.id,
                    light: {...el.light}
                  })
                }
                break;
              default:
                break;
            }
          }
        }
        window.unityInstance.SendMessage(
          char.objectId.toString(),
          'SetRotationWithJson',
          JSON.stringify(rotationJson)
        )
        window.unityInstance.SendMessage(
          char.objectId.toString(),
          'SetPositionWithJson',
          JSON.stringify(positionJson)
        )
        window.unityInstance.SendMessage(
          char.objectId.toString(),
          'SetScale',
          char.scale.toString()
        )
        // console.log(`{"id":"${char.objectId}","startTime":"${char.startTime}","endTime":"${char.endTime}"}`)
        window.unityInstance.SendMessage(
          char.objectId.toString(),
          'SetAssetTimeWithJson',
          `{"id":"${char.objectId}","startTime":"${char.startTime}","endTime":"${char.endTime}"}`
        )
      }
    },
    GetJSONFromID () {
      // console.log(this.story_id)
      // console.log(this.story_link)
      // this.SendStoryJsonToUnity(this.story_link)
      // storiesRef.child(this.selectedStoryId).on(
      //   'value',
      //   snapshot => {
      //     // console.log(snapshot.val());
      //     snapshot.forEach(child => {
      //       if (child.key == 'latest_export') {
      //         jsonFileStorageRef
      //           .child(this.selectedStoryId + '/' + child.val())
      //           .getDownloadURL()
      //           .then(url => {
      //             console.log(url)
      //             // this.SendStoryJsonToUnity(url)
      //           })
      //       }
      //     })
      //   },
      //   errorObject => {
      //     console.log('The read failed: ' + errorObject.name)
      //   }
      // )
    },
    SendStoryJsonToUnity (storyUrl) {
      window.unityInstance.SendMessage(
        'PreviewManager',
        'SetPreviewJSON',
        storyUrl
      )
    },
    whereMode() {
      unityInstance.SendMessage("TransformEditor","WhereMode","");
    },
    eulerMode() {
      unityInstance.SendMessage("TransformEditor","EulerMode","");
    },
    resizeMode() {
      unityInstance.SendMessage("TransformEditor","ResizeMode","");
    },
    selectCharacter (characterId) {
      var found = false
      const newChars = this.characters.map((char, index) =>
        char.hasOwnProperty('objectId') && char['objectId'] == characterId
          ? (() => {
            found = true
            activeCharacter = index
            return { ...char, active: true }
          })()
          : { ...char, active: false }
      )
      if (found) {
        console.log('The desired character has been selected')
      } else {
        console.log(
          "The desired character isn't existing, please check the passed id"
        )
      }
    },
    set (path, value, obj) {
      var schema = obj
      var pList = path.split('.')
      var len = pList.length
      for (var i = 0; i < len - 1; i++) {
        var elem = pList[i]
        if (!schema[elem]) schema[elem] = {}
        schema = schema[elem]
      }
      schema[pList[len - 1]] = value
    },
    editCharacter (name, value, characterId) {
      characterId && this.selectCharacter(characterId)
      var index = this.getSelectedCharacterIndex()
      this.set(name, value, this.characters[index])
      var newCharacters = this.characters
      newCharacters[index] = this.characters[index]
      return newCharacters
    },
    getSelectedCharacterIndex () {
      let charIndex
      const newChars = characters.filter(
        (char, index) =>
          char.hasOwnProperty('objectId') &&
          (() => {
            if (char['active'] != true) {
              return false
            } else {
              charIndex = index
              return true
            }
          })()
      )
      newChars.length > 1 && console.log('error')
      return charIndex
    },
    getSelectedCharacterObjectId () {
      return characters[this.getSelectedCharacterIndex()]['objectId']
    },
    deleteCharacter (id) {
      if (id) {
        window.unityInstance.SendMessage(
          'AssetHandler',
          'RemoveAssetWithId',
          id.toString()
        )
      }
      // console.log(newChars);
    }
  },
  computed: {
    ...mapGetters(['getModel','getSelectedStoryId']),
    ...mapState(['characters','selectedStoryId'])
  },
  watch: {
    characters: {
      handler: function (val, oldVal){
        for (let index = 0; index < val.length; index++) {
          const char = val[index]
          if (!this.spawned.filter(el => el.id == char.objectId).length > 0) {
            this.spawn(char)
            // console.log('spawned')
            this.spawned.push({
              id: char.objectId,
              char
            })
          } else {
            this.updateCharacter(char)
          }
        }
        this.activeCharacter = val.filter(el => !el.active)[0]
      },
      deep: true
    
    }
  },
}
</script>

<style scoped lang="scss">
.loader {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  //background-color: #161E31;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .loadingCount {
    color: #B3BDDE;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
    font-size: 1.5em;
  }
}
@keyframes ldio-0nttyi2ot5a {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
.ldio-0nttyi2ot5a div {
  position: relative;
  width: 80px;
  height: 80px;
  border: 10px solid #B3BDDE;
  border-top-color: transparent;
  border-radius: 50%;
}
.ldio-0nttyi2ot5a div {
  animation: ldio-0nttyi2ot5a 1s linear infinite;
  top: 100px;
  left: 100px;
}
.loadingio-spinner-rolling-20i2673fhl9 {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
  background: transparent;
}
.ldio-0nttyi2ot5a {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-0nttyi2ot5a div {
  box-sizing: content-box;
}
#unity-container,
#unity-canvas {
  position: relative;
  width: 100%;
  height: 100%;
}

#unity-container .mobile-controls {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  .btn {
    color: white;
    border-radius: 50%;
    background-color: #B3BDDE;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 10px;
    width: 50px;
    height: 50px;
    margin: 10px;
    &:hover {
      background-color: #B3BDDE;
    }

    &:nth-child(3) {
      width: 64px;
      height: 64px;
    }

    svg {
      width: 20px;
      height: 20px;
    }

    #play_SVG {
      display: none;
    }
  }
}
@media screen and (min-width: 821px) {
  #unity-container .mobile-controls {
    display: none;
  }
.preview-controls {
  position: absolute;
  top: 0;
  right: 0;
  padding: 15px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  .btn {
    border-radius: 10px;
    background-color: #283046;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 10px;
    width: 36px;
    height: 36px;
    margin: 5px;
    color: white;
    &:hover {
      background-color: #7367f0;
    }
    svg {
      width: 20px;
      height: 20px;
    }
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/newPreview.vue